/* eslint-disable react/jsx-no-bind */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useRouter } from 'next/router';
import React, { useContext, useRef, useEffect, useState } from 'react';
import { ASAP, SCHEDULE } from '../constants/deliveryType';
import notificationTypes from '../constants/modalNotificationConst';
import appContext from '../Context/appContext';
import * as WEBSITES from '../constants/website';
import { useDispatch, useSelector } from 'react-redux';
import { useDeliveryDetails } from '../hooks/app';
import { isNewHomePageApplicable } from '../constants/feature';
import { DEFAULT_ZIPCODE } from '../constants/default';
import RenderMinutes from './DeliveryTabs/RenderMinutes';
import RenderSeconds from './DeliveryTabs/RenderSeconds';
import RenderProdCount from './DeliveryTabs/RenderProdCount';
import { setMiniTabs } from '../redux/slices/otherSlice';
import DeliveryTimingSchedule from './DeliveryTimingSchedule';
import { pushNotification, pushNotificationOverlap, pushOnTopIfNotPresent } from '../redux/slices/modalSlice';
import DeliveryTiming from './DeliveryTiming';

const testOtherDays = date => {
  return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].some(day => date.includes(day));
};

const DeliveryTabs = ({
  setTab,
  currentTab,
  asapProductsCount,
  scheduledProductsCount,
  asapEnabled,
  scheduleEnabled,
  hasAsapProducts = true,
  hasScheduleProducts = true,
  className,
  openInPopup,
  hideWhatsThis = false,
  forMiniTabs = false
}) => {
  // const {
  //   dispatch
  // } = useContext(appContext);
  const dispatchRedux = useDispatch()
  const notifications = useSelector(state => state.modal.notifications)
  const { postcode = DEFAULT_ZIPCODE } = useSelector(state => state.user.deliveryDetails)
  const router = useRouter();
  const { route, pathname } = router;
  const {
    data: { asapReOpensAt, asapStartTime, noScheduleSlotsMessage }
  } = useDeliveryDetails(false, true);

  const [timeData, setTimeData] = React.useState({});
  const [remainingTime, setRemainingTime] = useState(-1);
  const [asapOpen, setasapOpen] = useState(false);
  const [hideDeliveryTabs, setHideDeliveryTabs] = useState(false);
  const [tabLocal, setLocalTab] = useState(currentTab)

  const isScheduleDisabled = !scheduleEnabled;

  const headerRef = useRef();
  const interval = useRef(null);
  const currentTime = new Date().toLocaleTimeString('en-US', { timeZone: 'America/Los_Angeles', hourCycle: 'h23' });



  const showAvailableDelivery = () => {
    const scheduleSlotOpen = notifications.map(notification => notification.type).includes(notificationTypes.scheduleSlot);
    if (!scheduleSlotOpen) {
      dispatchRedux(pushNotificationOverlap({
        type: notificationTypes.scheduleSlot,
        data: { noScheduleSlotsMessage, hideRadioButtons: !isNewHomePageApplicable }
      }))
    }
  };

  useEffect(() => {
    if (asapReOpensAt && asapStartTime) {
      const currentTimeArray = currentTime.split(':');
      const asapTimeArray = asapStartTime.split(':');
      if (currentTimeArray.length === 3 && asapTimeArray.length === 3) {
        let currentTimeHigherFlag = false;
        let hourDifference = 0;
        let minutesDifference = 0;
        let secondsDifference = 0;
        const diff = parseInt(24 - currentTimeArray[0]) + parseInt(asapTimeArray[0]);

        if (
          testOtherDays(asapReOpensAt) ||
          (asapReOpensAt.toLowerCase().includes('tomorrow') &&
            (diff > 24 || (diff === 24 && parseInt(asapTimeArray[1]) >= parseInt(currentTimeArray[1]))))
        ) {
          setTimeData({});
          setHideDeliveryTabs(true);
          return;
        }

        if (currentTimeArray[0] > asapTimeArray[0]) {
          hourDifference = 24 - parseFloat(currentTimeArray[0]) + parseFloat(asapTimeArray[0]);
          currentTimeHigherFlag = false;
        } else if (currentTimeArray[0] == asapTimeArray[0] && currentTimeArray[1] > asapTimeArray[1]) {
          hourDifference = 23 - parseFloat(currentTimeArray[0]) + parseFloat(asapTimeArray[0]);
          currentTimeHigherFlag = true;
        } else {
          hourDifference = parseFloat(asapTimeArray[0]) - parseFloat(currentTimeArray[0]);
        }

        if (currentTimeArray[1] > asapTimeArray[1]) {
          minutesDifference = parseFloat(60 - currentTimeArray[1]) + parseFloat(asapTimeArray[1]);
          hourDifference -= currentTimeHigherFlag ? 0 : 1;
        } else {
          minutesDifference = parseFloat(asapTimeArray[1]) - parseFloat(currentTimeArray[1]);
        }

        if (currentTimeArray[2] > asapTimeArray[2]) {
          secondsDifference = parseFloat(60 - currentTimeArray[2]) + parseFloat(asapTimeArray[2]);
          minutesDifference -= 1;
        } else {
          secondsDifference = parseFloat(asapTimeArray[2]) - parseFloat(currentTimeArray[2]);
        }

        setTimeData({
          hours: hourDifference,
          minutes: minutesDifference,
          seconds: secondsDifference
        });
        if (setTab) setTab(SCHEDULE);
      }
    } else {
      setTimeData({});
      setHideDeliveryTabs(false);
    }
  }, [asapReOpensAt, asapStartTime]);

  const [deliveryTimeDetails] = useState({
    remainingSeconds: remainingTime % 60,
    remainingMinutes: parseInt(remainingTime / 60) % 60,
    remainingHours: parseInt(remainingTime / 3600)
  });

  const { remainingSeconds, remainingMinutes, remainingHours } = deliveryTimeDetails;

  useEffect(() => {
    (deliveryTimeDetails.remainingSeconds = remainingTime % 60),
      (deliveryTimeDetails.remainingMinutes = parseInt(remainingTime / 60) % 60),
      (deliveryTimeDetails.remainingHours = parseInt(remainingTime / 3600));
  }, [remainingTime]);

  // const remainingSeconds = remainingTime % 60;
  // const remainingMinutes = parseInt(remainingTime / 60) % 60;
  // const remainingHours = parseInt(remainingTime / 3600);

  useEffect(() => {
    const { hours = 0, minutes = 0, seconds = 0 } = timeData || {};
    if (Object.keys(timeData).length) {
      setRemainingTime(hours * 3600 + minutes * 60 + seconds);
    }
  }, [timeData]);

  const clearIntervals = () => {
    clearInterval(interval.current);
  };

  useEffect(() => {
    const calculateAndSetTime = () => {
      if (remainingTime > 0) {
        setRemainingTime(remainingTime - 1);
      } else if (remainingTime == 0) {
        setasapOpen(true);
        setTimeData({});
      }
    };
    interval.current = setInterval(() => {
      calculateAndSetTime();
    }, 1000);

    return () => {
      clearIntervals();
    };
  }, [remainingTime, postcode]);
  useEffect(() => {
    const { hours = 0, minutes = 0, seconds = 0 } = timeData || {};
    if (Object.keys(timeData).length) {
      setRemainingTime(hours * 3600 + minutes * 60 + seconds);
    }
  }, [timeData]);

  useEffect(() => {
    const currentRef = headerRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio === 0) {
          // dispatch({ type: 'setMiniTabs', payload: true });
          dispatchRedux(setMiniTabs(true))
        } else {
          // dispatch({ type: 'setMiniTabs', payload: false });
          dispatchRedux(setMiniTabs(false))
        }
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0
      }
    );

    if (currentRef && !forMiniTabs) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [headerRef.current]);

  if (isNewHomePageApplicable && !asapOpen && timeData && Object.keys(timeData).length) {
    return (
      <div className="text-center">
        <div className="asapcounter d-lg-flex">
          <div className="counterheader fs-12 fw-600 d-flex align-items-center justify-content-center">
            <div>
              {/* <i className="icon-stopwatch l-icon" />
              <span>ASAP Back in </span> */}
              <span className='text-[12px] md:text-[16px] font-[400]'>Super Fast  </span>
              <div className="counter">
                <span>Back in</span> <b>{`${remainingHours > 0 ? `${remainingHours}h:` : '00h'}`}{' '}
                  <RenderMinutes remainingMinutes={remainingMinutes} remainingHours={remainingHours} />
                  <RenderSeconds remainingSeconds={remainingSeconds} remainingMinutes={remainingMinutes} /></b>
                {/* {`${remainingHours > 0 ? `${remainingHours}h:` : '00h'}`}{' '}
                <RenderMinutes remainingMinutes={remainingMinutes} remainingHours={remainingHours} />
                <RenderSeconds remainingSeconds={remainingSeconds} remainingMinutes={remainingMinutes} /> */}
              </div>
            </div>
          </div>
          {!isScheduleDisabled ? (
            <div className="scheduled-tab text-[12px] md:text-[16px] font-[400] height-100 bg-secondary-color !important">
              {/* <i className="icon-calendar-line l-icon" /> */}
              Scheduled <RenderProdCount productCount={scheduledProductsCount} />{' '}
              <div onClick={() => tabLocal == SCHEDULE && showAvailableDelivery()} className={` mt-1 font-normal ${tabLocal == SCHEDULE ? 'text-white' : 'text-secondary-color'} !important text-[12px]`}>
                <DeliveryTimingSchedule onlyText currentTab={tabLocal} />
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  if (!hasAsapProducts) {
    setTab(SCHEDULE);
  }
  if (!hasScheduleProducts) {
    setTab(ASAP);
  }

  if (!asapEnabled || !scheduleEnabled || !hasAsapProducts || !hasScheduleProducts) {
    return <div ref={headerRef} />;
  }

  const isProductPage =
    (notifications.length && notifications[0].type == notificationTypes.productDetails) || pathname.includes('product');

  return (
    <div className="text-center">
      <div id="delivery-tabs-box" className={`delivery-tabs  d-flex asapcounter !bg-transparent product-delivery-tabs ${className}`} ref={headerRef}>
        {hasAsapProducts || isProductPage ? (
          <div
            className={`m-item counterheader fs-12 fw-600 d-flex flex-col align-items-center justify-content-center ${!asapEnabled ? 'disable-click disable-tab' : ''} ${currentTab == ASAP ? 't-selected' : ''}`}
            test-id="#delivery_tab_asap"
            onClick={() => {
              if (asapEnabled) setTab(ASAP);
              if (route == '/product/[slug]') {
                return;
              }
              if (!openInPopup) {
                window.scrollTo(0, 0);
              }
            }}
          >
            <div className='text-[14px] md:text-[16px]'>
              <div className="d-flex flex-column flex-lg-row justify-content-center m-item-content">
                <div className="content">
                  {/* <i className="icon-stopwatch l-icon d-none d-lg-inline" /> */}
                  <div className=" text-[14px] md:text-[16px] font-[400]">
                    {`${process.env.NEXT_PUBLIC_APP === WEBSITES.GOVANA ? 'Order Now' : 'Super Fast '}`}
                  </div>
                </div>
                <div className="products-availability">
                  <strong>
                    {' '}
                    {!asapEnabled
                      ? '0 products'
                      : asapProductsCount === null
                        ? 'Loading...'
                        : !asapProductsCount
                          ? '0 products'
                          : `${asapProductsCount || '--'} products`}
                  </strong>
                </div>
              </div>
              <div className="mini-tab-section">
                {/* <i className="icon-stopwatch l-icon" /> */}
                Super Fast (
                {!asapEnabled
                  ? '0'
                  : asapProductsCount === null
                    ? '...'
                    : !asapProductsCount
                      ? '0'
                      : `${asapProductsCount || '--'}`}){' '}
              </div>
            </div>
            <div className='text-[12px] text-secondary-color font-[400] mt-[3px]'>

              <DeliveryTiming onlyText currentTab={"asap"} />
            </div>
          </div>
        ) : null}

        {hasScheduleProducts || isProductPage ? (
          <div
            className={`m-item scheduled-tab text-[12px] md:text-[16px] font-[400] height-100 bg-secondary-color !important d-flex flex-col justify-content-center align-items-center  ${currentTab == SCHEDULE ? 't-selected' : ''}`}
            test-id="#delivery_tab_schedule"
            onClick={() => {
              setTab(SCHEDULE);
              if (route == '/product/[slug]') {
                return;
              }
              if (!openInPopup) {
                window.scrollTo(0, 0);
              }
            }}
          >
            <div className='text-[16px]'>
              <div className="d-flex flex-column flex-lg-row justify-content-center m-item-content">
                <div className="content">
                  {/* <i className="icon-calendar-line l-icon d-none d-lg-inline" /> */}
                  <div className="text-[14px] md:text-[16px] font-[400] d-inline">
                    {`${process.env.NEXT_PUBLIC_APP === WEBSITES.GOVANA ? 'Schedule Later' : 'Scheduled Menu'} `}
                  </div>
                </div>
                <div className="products-availability">
                  <strong>
                    {scheduledProductsCount === null
                      ? 'Loading...'
                      : !scheduledProductsCount
                        ? '0 products '
                        : `${scheduledProductsCount || '--'} products `}
                  </strong>
                </div>
              </div>
              <div className="mini-tab-section">
                {/* <i className="icon-calendar-line l-icon" /> */}
                <div className="text-[14px] md:text-[16px] font-[400] d-inline-block"> Scheduled </div>(
                {scheduledProductsCount === null ? '...' : !scheduledProductsCount ? '0 ' : `${scheduledProductsCount || '--'}`})
              </div>
            </div>
            <div onClick={() => currentTab === SCHEDULE && dispatchRedux(pushNotificationOverlap({
              type: notificationTypes.scheduleSlot,
              data: { noScheduleSlotsMessage, hideRadioButtons: !isNewHomePageApplicable }

            }))} className='text-[12px] text-secondary-color font-[400] mt-[5px]'>
              <DeliveryTimingSchedule inPopup onlyText currentTab={currentTab} />
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default DeliveryTabs;
